/* External Imports */
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';

const AboutDeviSlide5 = ({ section }) => {
  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684474033-ib_secion5bg.jpeg) no-repeat center top`}
      bgSize="cover !important"
      bgColor="#000"
      className={styles.section5Bg}
      overflow="hidden"
    >
      <Box
        maxW="1200px"
        width="100%"
        px={{ base: 4, md: 7 }}
        py={{ base: 6, md: '1rem' }}
        mx="auto"
      >
        <Box
          w="100%"
          pos={{ base: 'static', md: 'relative' }}
          top={{ base: '0rem', md: '9rem' }}
          right="0rem"
          display="flex"
          justifyContent="flex-end"
        >
          <Text
            pos={{ base: 'static', md: 'relative' }}
            w={{ base: '13rem', sm: '15rem', lg: '27rem' }}
            color="#fff"
            fontSize={{ base: '18px', lg: '24px' }}
            textAlign="end"
          >
            {section?.sectionContent?.[0]?.text}
          </Text>
        </Box>
        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475449-lb_sadhguru_img3.png`,
            lg: `${config.imgPath}/d/46272/1684475449-lb_sadhguru_img3.png`,
          })}
          alt="sadhguru_img3"
          width={useBreakpointValue({
            base: '27rem',
            md: '33rem',
            lg: '29rem',
          })}
          pos="relative"
          top={{ base: '2rem', md: '-7rem' }}
          left={{ base: '0px', lg: '6rem' }}
          pr={{ base: '7rem', md: '4rem' }}
          zIndex="3"
        />

        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475443-lb_sadhguru_img4.png`,
            lg: `${config.imgPath}/d/46272/1684475443-lb_sadhguru_img4.png`,
          })}
          alt=""
          width={useBreakpointValue({
            base: '27rem',
            md: '33rem',
            lg: '29rem',
          })}
          position="relative"
          pl={{ base: '6rem', md: '4rem' }}
          top={{ base: '0px', md: '-9rem', lg: '11rem', xl: '9rem' }}
          left={{ base: '0rem', md: '10rem', lg: '-9rem', xl: '-5rem' }}
          zIndex="2"
        />

        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475438-lb_sadhguru_img5.png`,
            lg: `${config.imgPath}/d/46272/1684475438-lb_sadhguru_img5.png`,
          })}
          alt=""
          width={useBreakpointValue({
            base: '27rem',
            md: '33rem',
            lg: '29rem',
          })}
          position="relative"
          top={{ base: '-1rem', md: '-10rem', lg: '-4rem', xl: '-1rem' }}
          left={{ base: '0rem', lg: '2rem', xl: '5rem' }}
          pr={{ base: '6rem', md: '4rem' }}
          zIndex="1"
        />
      </Box>
    </Box>
  );
};
export default AboutDeviSlide5;
